import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Injectable({ providedIn: 'root' })
@Pipe({
	name: 'arrayJoin'
})
export class ArrayJoinPipe implements PipeTransform {
	transform(array: Array<any>, delimiter = ','): string {
		return array.join(delimiter);
	}
}
